import { Modal } from "@4uhub/lib4uhub";
import { Box, Button, Stack, Typography } from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";

interface IClearConfirmationModalProps {
  openDeleteAlert: boolean;
  handleConfirmClear: () => void;
  handleCloseAlert: () => void;
}

const translationPath = "page.4uBus.register.iService.";

export const ClearConfirmationModal = memo(
  ({
    openDeleteAlert,
    handleConfirmClear,
    handleCloseAlert,
  }: IClearConfirmationModalProps) => {
    const { t } = useTranslation();

    return (
      <Modal
        open={openDeleteAlert}
        onClose={handleCloseAlert}
        title={
          t(translationPath + "confirm_delete_title") || "Confirm Deletion"
        }
      >
        <Box sx={{ p: 2 }}>
          <Typography variant="body1" sx={{ mb: 4 }}>
            {t(translationPath + "confirm_delete_message")}
          </Typography>

          <Stack direction="row" spacing={2} justifyContent="flex-end">
            <Button variant="outlined" onClick={handleCloseAlert}>
              {t(translationPath + "cancel")}
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={handleConfirmClear}
            >
              {t(translationPath + "confirm_clear")}
            </Button>
          </Stack>
        </Box>
      </Modal>
    );
  },
);
